export const getPowerReviewAPIKeys = async (getcustomPreferencevalue) => {
    try {
        let prAPIKeysResult = ''
        const powerReviewApiKey = getcustomPreferencevalue('pwaPowerReviewsApiKey')
        const merchantGroupID = getcustomPreferencevalue('pwaPowerReviewsMerchantGroupId')
        const merchantID = getcustomPreferencevalue('pwaPowerReviewsMerchantId')
        if (powerReviewApiKey) {
            prAPIKeysResult = {
                powerReviewApiKey,
                merchantGroupID,
                merchantID
            }
        }
        return prAPIKeysResult
    } catch (error) {
        console.error('Error fetching PowerReview API keys:', error)
        return null
    }
}

export const showTileRatings = async (result) => {
    if (!result) return
    const productTileList = document.querySelectorAll('.category-snippet')
    const prReviewClassList = document.querySelectorAll('.pr-snippet.pr-category-snippet')
    const prNoReviewClassList = document.querySelectorAll('.pr-no-reviews')
    let prStruct = []
    let reviewObj

    productTileList.forEach((productTileItem, index) => {
        if (productTileItem) productTileItem.innerHTML = ''
        const pageIdValue =
            productTileItem.getAttribute('data-product-id') ||
            productTileItem.id.substring(17) ||
            ''
        productTileItem.id = `category-snippet-${pageIdValue}-${index}`
        reviewObj = {
            api_key: result.powerReviewApiKey,
            merchant_group_id: result.merchantGroupID,
            merchant_id: result.merchantID,
            page_id: pageIdValue,
            components: {
                CategorySnippet: productTileItem.id
            }
        }
        if (!(prStruct.filter((e) => e.page_id === pageIdValue).length > 0)) {
            prStruct.push(reviewObj)
        }
    })

    if (
        typeof POWERREVIEWS != 'undefined' &&
        prReviewClassList.length < 1 &&
        prNoReviewClassList.length < 1
    ) {
        window.POWERREVIEWS.display.render(prStruct)
    }
}

// show reviews for PLP & PDP tiles
export const showPLPAndPDPTileRatings = (result, isPDP, writeAReviewObject) => {
    if (!result) return

    const productTileList = document.querySelectorAll('.category-snippet')
    let prStruct = []

    if (isPDP && writeAReviewObject) {
        //  PDP → full reset
        if (typeof window.POWERREVIEWS !== 'undefined' && window.POWERREVIEWS?.display?.unmount) {
            window.POWERREVIEWS.display.unmount()
        }
        const mounted = document.getElementById('pr-reviewsnippet')
        const reviewsDisplay = document.getElementById('pr-reviewdisplay')

        if (mounted) mounted.innerHTML = ''
        if (reviewsDisplay) reviewsDisplay.innerHTML = ''
        prStruct.push(writeAReviewObject)
    }

    productTileList.forEach((productTileItem, index) => {
        const pageIdValue =
            productTileItem.getAttribute('data-product-id') ||
            productTileItem.id.substring(17) ||
            ''
        productTileItem.id = `category-snippet-${pageIdValue}-${index}`

        const existingSnippets = productTileItem.querySelectorAll('.pr-snippet.pr-category-snippet')
        if (existingSnippets && existingSnippets.length > 0) {
            // if more than 1 snippet → keep only the first
            existingSnippets.forEach((snippet, idx) => {
                if (idx > 0) snippet.remove()
            })
            return // skip re-rendering this tile
        }

        prStruct.push({
            api_key: result.powerReviewApiKey,
            merchant_group_id: result.merchantGroupID,
            merchant_id: result.merchantID,
            page_id: pageIdValue,
            components: {
                CategorySnippet: productTileItem.id
            }
        })
    })

    if (typeof POWERREVIEWS !== 'undefined' && prStruct.length > 0) {
        window.POWERREVIEWS.display.render(prStruct)
        setTimeout(() => {
            document.querySelectorAll('.category-snippet').forEach((tile) => {
                const snippets = tile.querySelectorAll('.pr-snippet.pr-category-snippet')
                if (snippets.length > 1) {
                    snippets.forEach((snippet, idx) => {
                        if (idx > 0) snippet.remove() // keep only first
                    })
                }
            })
        }, 2000)
    }
}

// init logic for PLP & PDP
export const initPowerReviewsForPLPAndPDP = async (result, isPDP, writeAReviewObject) => {
    if (!result) return

    // wait until page load is complete
    if (document.readyState !== 'complete') {
        await new Promise((resolve) => window.addEventListener('load', resolve, {once: true}))
    }

    // initial load
    showPLPAndPDPTileRatings(result, isPDP, writeAReviewObject)

    let debounceTimer
    let lastTileCount = document.querySelectorAll('.category-snippet').length

    const observer = new MutationObserver(() => {
        const currentCount = document.querySelectorAll('.category-snippet').length
        if (currentCount <= lastTileCount) return // nothing new
        lastTileCount = currentCount

        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => {
            requestAnimationFrame(() => {
                showPLPAndPDPTileRatings(result, isPDP, writeAReviewObject)

                const loadedPR = document.querySelectorAll('.pr-snippet.pr-category-snippet').length
                if (loadedPR >= lastTileCount) {
                    observer.disconnect()
                }
            })
        }, 300)
    })

    // observe only carousel wrappers if present, else fallback to body
    const carousels = document.querySelectorAll('.product-wrapper')
    if (carousels.length > 0) {
        carousels.forEach((carousel) => {
            observer.observe(carousel, {childList: true, subtree: true})
        })
    } else {
        observer.observe(document.body, {childList: true, subtree: true})
    }
}
